
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export function useWorkflowActions() {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleComplete = async () => {
    try {
      // Mark onboarding as complete if there's a partial business record
      const { data: session } = await supabase.auth.getSession();
      
      if (!session?.session) {
        toast({
          title: "Authentication required",
          description: "Please sign in to complete setup.",
          variant: "destructive",
        });
        navigate("/auth");
        return;
      }
      
      // Get the business record
      const { data: businessData } = await supabase
        .from('business')
        .select('id, is_onboarding_complete')
        .eq('owner_id', session.session.user.id)
        .single();
      
      if (businessData && !businessData.is_onboarding_complete) {
        // Update the onboarding status
        await supabase
          .from('business')
          .update({ is_onboarding_complete: true })
          .eq('id', businessData.id);
      }
      
      toast({
        title: "Setup Complete!",
        description: "Your AI Assistant is ready to help you grow your business.",
      });
      
      navigate("/app");
    } catch (error) {
      console.error("Error completing workflow:", error);
      toast({
        title: "Error",
        description: "An error occurred while completing setup.",
        variant: "destructive",
      });
    }
  };

  return {
    handleComplete
  };
}
